module.exports = __webpack_public_path__ + "img/full2-min.b542f057.png";